import React, { useState, useCallback, useMemo } from 'react';
import { Formik, useField } from 'formik';
import { Grid, Typography, Box, Button, Slider, TextField as MUITextField, IconButton, DialogActions, DialogTitle, List, ListItem, ListItemText } from '@mui/material';
import { postCommand, useRefresh } from '../../data/fetch';
import { COMMAND } from '../../../common';
import { TextField, ToggleField, Autocomplete, DateField, EnumField } from '../../components/input';


export default function PrepareDialog(props) {
  let { rec } = props.open;
  let refresh = useRefresh();
  const submit = async (updates) => {
    await postCommand('delivery', COMMAND.UPDATE_TRACKINGNR, { delivery: rec.id, updates });
    refresh();
    props.close();
  }

  let { trackingnr, ekaer, uit} = rec;

  return <Formik initialValues={{ trackingnr, ekaer, uit }} onSubmit={submit}>{({ handleSubmit, isSubmitting, errors }) => (
    <form onSubmit={handleSubmit} style={{ height: '100%', overflow: 'auto', display: 'flex', flexDirection: 'column' }} autocomplete="off">
      <DialogTitle>Szállítási referenciák</DialogTitle>
      <Grid container sx={{ p: 2 }} columnSpacing={2}>
        <Grid item xs={12} md={4}>
          <TextField name="trackingnr" label="Tracking Nr." />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField name="ekaer" label="EKAER szám" />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField name="uit" label="UIT szám" />
        </Grid>
      </Grid>
      <DialogActions>
        <Button sx={{ color: "text.secondary" }} onClick={() => props.cancel()}>Mégsem</Button>
        <Button variant="contained" type="submit" disabled={Object.keys(errors).length !== 0 || isSubmitting}>Mentés</Button>
      </DialogActions>
    </form >
  )}
  </Formik>
}